/**
 * Comprehensive list of grape varieties for autocomplete.
 * Sorted alphabetically. Entries with "/" in the source have been split
 * into separate items (e.g. "Syrah / Shiraz" → "Syrah" + "Shiraz").
 */
export const GRAPE_VARIETIES: string[] = [
  'Agiorgitiko',
  'Aglianico',
  'Airén',
  'Albariño',
  'Aleatico',
  'Alicante Bouschet',
  'Aligoté',
  'Altesse',
  'Alvarinho',
  'Ancellotta',
  'Ansonica',
  'Aragonez',
  'Arinto',
  'Arneis',
  'Assyrtiko',
  'Auxerrois',
  'Bacchus',
  'Baco Noir',
  'Baga',
  'Barbarossa',
  'Barbera',
  'Bastardo',
  'Blaufränkisch',
  'Bobal',
  'Bombino Bianco',
  'Bombino Nero',
  'Bonarda',
  'Bourboulenc',
  'Brachetto',
  'Brunello',
  'Cabernet Franc',
  'Cabernet Sauvignon',
  'Caladoc',
  'Canaiolo',
  'Cannonau',
  'Carignan',
  'Carménère',
  'Carricante',
  'Castelão',
  'Catarratto',
  'Cencibel',
  'Cesanese',
  'Chambourcin',
  'Chardonnay',
  'Chasselas',
  'Chenin Blanc',
  'Cinsault',
  'Clairette',
  'Colombard',
  'Colorino',
  'Cortese',
  'Corvina',
  'Corvinone',
  'Côt',
  'Counoise',
  'Criolla Grande',
  'Dolcetto',
  'Dornfelder',
  'Durella',
  'Durif',
  'Encruzado',
  'Erbaluce',
  'Falanghina',
  'Fer Servadou',
  'Fernão Pires',
  'Fetească Albă',
  'Fetească Neagră',
  'Fetească Regală',
  'Fiano',
  'Frappato',
  'Freisa',
  'Friulano',
  'Fumin',
  'Fumé Blanc',
  'Furmint',
  'Gaglioppo',
  'Gamay',
  'Garganega',
  'Garnacha',
  'Garnacha Blanca',
  'Garnacha Tintorera',
  'Gewürztraminer',
  'Glera',
  'Godello',
  'Graciano',
  'Grauburgunder',
  'Grechetto',
  'Greco',
  'Greco di Tufo',
  'Grenache',
  'Grenache Blanc',
  'Grenache Gris',
  'Grignolino',
  'Grillo',
  'Gros Manseng',
  'Grüner Veltliner',
  'Hondarrabi Zuri',
  'Inzolia',
  'Jacquère',
  'Kadarka',
  'Kékfrankos',
  'Kerner',
  'Lagrein',
  'Lambrusco',
  'Lemberger',
  'Len de l\'El',
  'Listan Negro',
  'Loureiro',
  'Macabeo',
  'Malagousia',
  'Malbec',
  'Malvasia',
  'Malvasia Bianca',
  'Malvasia di Candia',
  'Malvasia Nera',
  'Mammolo',
  'Mansois',
  'Manto Negro',
  'Maratheftiko',
  'Marsanne',
  'Marzemino',
  'Mauzac',
  'Mavrodaphne',
  'Mavrotragano',
  'Mazuelo',
  'Melon de Bourgogne',
  'Mencía',
  'Merlot',
  'Molinara',
  'Monastrell',
  'Mondeuse',
  'Montepulciano',
  'Morellino',
  'Moscatel',
  'Moscato',
  'Mourvèdre',
  'Müller-Thurgau',
  'Muscadelle',
  'Muscadet',
  'Muscat',
  'Muscat Blanc à Petits Grains',
  'Muscat of Alexandria',
  'Muscat Ottonel',
  'Nebbiolo',
  'Negroamaro',
  'Nero d\'Avola',
  'Nerello Cappuccio',
  'Nerello Mascalese',
  'Neuburger',
  'Nielluccio',
  'Nosiola',
  'Nuragus',
  'Oeillade',
  'Pallagrello Bianco',
  'Pallagrello Nero',
  'Palomino',
  'Pansa Blanca',
  'Parellada',
  'Passerina',
  'Pecorino',
  'Pedro Ximénez',
  'Pelaverga',
  'Perricone',
  'Petit Courbu',
  'Petit Manseng',
  'Petit Verdot',
  'Petite Sirah',
  'Peverella',
  'Picpoul',
  'Piedirosso',
  'Pigato',
  'Pinotage',
  'Pinot Bianco',
  'Pinot Blanc',
  'Pinot Grigio',
  'Pinot Gris',
  'Pinot Meunier',
  'Pinot Nero',
  'Pinot Noir',
  'Piquepoul',
  'Plavac Mali',
  'Poulsard',
  'Premetta',
  'Primitivo',
  'Prié Blanc',
  'Prokupac',
  'Prosecco',
  'Pugnitello',
  'Rabigato',
  'Raboso',
  'Refosco',
  'Riesling',
  'Rivaner',
  'Rkatsiteli',
  'Robola',
  'Roditis',
  'Rolle',
  'Romé',
  'Rondinella',
  'Rossese',
  'Rossignola',
  'Rotgipfler',
  'Roussanne',
  'Ruché',
  'Sagrantino',
  'Saint-Laurent',
  'Sangiovese',
  'Saperavi',
  'Sauvignon Blanc',
  'Sauvignon Gris',
  'Savagnin',
  'Schiava',
  'Schioppettino',
  'Scheurebe',
  'Sciacarello',
  'Sémillon',
  'Seyval Blanc',
  'Silvaner',
  'Spätburgunder',
  'Susumaniello',
  'Sylvaner',
  'Syrah',
  'Shiraz',
  'Tannat',
  'Tempranillo',
  'Teroldego',
  'Terrantez',
  'Terret Noir',
  'Tinta Amarela',
  'Tinta Barroca',
  'Tinta de Toro',
  'Tinta Negra',
  'Tinta Roriz',
  'Tinto Cão',
  'Tinto Fino',
  'Tocai Friulano',
  'Torrontés',
  'Touriga Franca',
  'Touriga Nacional',
  'Traminer',
  'Trebbiano',
  'Trebbiano d\'Abruzzo',
  'Trebbiano Toscano',
  'Treixadura',
  'Trepat',
  'Trollinger',
  'Trousseau',
  'Turbiana',
  'Ugni Blanc',
  'Uva di Troia',
  'Vaccarèse',
  'Valdiguié',
  'Verdeca',
  'Verdejo',
  'Verdicchio',
  'Verdil',
  'Verduzzo',
  'Vermentino',
  'Vernaccia',
  'Vernaccia di San Gimignano',
  'Vespaiola',
  'Vidal Blanc',
  'Vien de Nus',
  'Vignoles',
  'Viognier',
  'Viura',
  'Weissburgunder',
  'Welschriesling',
  'Xarel·lo',
  'Xinomavro',
  'Zibibbo',
  'Zierfandler',
  'Zinfandel',
  'Zweigelt',
];
